import { createSelector } from 'reselect';

export const currencyConvertorSelector = createSelector(
  (state) => state.newJob.convertCurrency,
  ({ targetCurrencyValue }) => targetCurrencyValue,
);
